export const STATUS_MESSAGES = {
  ESG_PASS:
    'บริษัทจัดทำ ESG Structured Data และเผยแพร่ ESG Structured Data  บนระบบ ESG Data Platform แล้ว',
  ESG_NOT_PASS: 'บริษัทจัดทำ ESG Structured Data น้อยกว่าเกณฑ์ที่กำหนด',
  CGR_PASS: 'บริษัทท่านสามารถจัดทำแผน Corporate Value Up ได้',
  CGR_NOT_PASS:
    'บริษัทท่านได้รับคะแนน CGR Score น้อยกว่าเกณฑ์ที่กำหนด ท่านยังสามารถจัดทำแผน Corporate Value Up ได้ แต่บริษัทจะไม่อยู่ในรายชื่อ Thai ESG List',
  CGR_SCORE_NULL: 'ไม่พบข้อมูลคะแนน CGR Score',
  GET_API_CGR_FAIL: 'ระบบไม่สามารถดึงข้อมูล CGR Score ได้กรุณาลองใหม่อีกครั้ง',
};
